module.exports = "https://web-assets.ifttt.com/packs/media/activity/chevron-ea8e6910.svg";